import { render, staticRenderFns } from "./TransferenciasPremiosFiltro.vue?vue&type=template&id=a1bc8530&"
import script from "./TransferenciasPremiosFiltro.vue?vue&type=script&lang=js&"
export * from "./TransferenciasPremiosFiltro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports